// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardPartStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {
  var ReportPartDetails = require('logic/models/Izenda.ReportPartDetails');
  var DashboardTile = require('logic/models/Dashboard/Izenda.DashboardTile');

  var DashboardStore = require('logic/Izenda.DashboardStore');

  function DashboardPartStore() {
    this.sourceStore = new DashboardStore();
  }

  /**
   * Load definition and data of dashboard's part.
   * @param  {String} dashboardPartId
   */
  DashboardPartStore.prototype.loadReportPartContentFromDashboard = function (dashboardPartId) {
    var sourceStore = this.sourceStore;
    var content;

    return sourceStore.loadDashboardPartDefinition(dashboardPartId)
      .then(function (info) {
        content = new DashboardTile(info);
        if (content.reportPartId) {
          return sourceStore.loadReportPartDefinition(content.reportPartId);
        }

        return Promise.resolve();
      })
      .then(function (detail) {
        if (detail) {
          content.reportPart = new ReportPartDetails(detail);
          return sourceStore.getReportPartData(content);
        }
        return Promise.resolve();
      })
      .then(function (result) {
        return {
          part: content,
          sourceStore: sourceStore
        };
      });
  };

  module.exports = DashboardPartStore;
}());



// WEBPACK FOOTER //
// ./ui/logic/Izenda.DashboardPartStore.js